import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import {atomIconSizes} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import {useSuiContext} from '@s-ui/react-context'
import PrimitiveTypography, {primitiveTypographyDesign} from '@s-ui/react-primitive-typography'
import IconBinOutline from '@adv-mt/mt-svg-icons/lib/BinOutline'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'
import TitleBasic, {titleBasicSizes} from '@adv-mt/mt-title-basic'

const BASE_CLASS = 'mt-ComparatorButton'
const DEFAULT_PHOTO = 'images/no-photo-ad-card.svg'

const ComparatorContent = ({comparatorSelectedAds, onRemoveSelectedAd, clearSelectedAds, onClickShow, onClose}) => {
  const {i18n, domain} = useSuiContext()

  const config = domain.get('config')
  const urlStatics = config.get('urlStatics')
  const defaultPhotoSrc = `${urlStatics}${DEFAULT_PHOTO}`

  const className = `${BASE_CLASS}-drawerContainer`

  return (
    <div className={className}>
      <div className={`${className}-content`}>
        <div className={`${className}-header`}>
          <TitleBasic
            id="comparator-modal-title"
            title={i18n.t('COMPARATOR.ADS_LIST_MODAL_TITLE', comparatorSelectedAds.length)}
            size={titleBasicSizes.xs}
          />
          <AtomButton
            design={atomButtonDesigns.FLAT}
            onClick={onClose}
            leftIcon={<IconClose size={atomIconSizes.medium} />}
            aria-label={i18n.t('COMMON_CLOSE')}
          />
        </div>

        <ul>
          {comparatorSelectedAds.map(ad => (
            <li className={`${className}-item`} key={ad.id}>
              <AtomImage alt="" src={ad.img || ad.photos?.[0] || defaultPhotoSrc} className={`${className}-image`} />
              <PrimitiveTypography design={primitiveTypographyDesign.BODY_2} className={`${className}-name`}>
                {ad.title}
              </PrimitiveTypography>
              <AtomButton
                design={atomButtonDesigns.FLAT}
                onClick={() => onRemoveSelectedAd(ad)}
                leftIcon={<IconBinOutline size={atomIconSizes.medium} />}
                aria-label={i18n.t('COMPARATOR.DELETE_AD')}
              />
            </li>
          ))}
        </ul>
      </div>
      <div className={`${className}-buttonsWrapper`}>
        <AtomButton
          design={atomButtonDesigns.FLAT}
          size={atomButtonSizes.LARGE}
          shape={atomButtonShapes.CIRCULAR}
          onClick={clearSelectedAds}
        >
          {i18n.t('COMMON.REMOVE')}
        </AtomButton>
        <AtomButton
          design={atomButtonDesigns.OUTLINE}
          size={atomButtonSizes.LARGE}
          shape={atomButtonShapes.CIRCULAR}
          isFitted
          onClick={onClickShow}
        >
          {i18n.t('COMPARATOR.ADS_LIST_MODAL_CTA_SHOW')}
        </AtomButton>
      </div>
    </div>
  )
}

ComparatorContent.displayName = 'ComparatorContent'

ComparatorContent.propTypes = {
  comparatorSelectedAds: PropTypes.array,
  onRemoveSelectedAd: PropTypes.func,
  clearSelectedAds: PropTypes.func,
  onClickShow: PropTypes.func,
  onClose: PropTypes.func
}

export default ComparatorContent
